<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.referUser.avatar 
      ? `https://selfie.cash/avatar/${params.data.referUser.avatar}`
      : require('@/assets/images/avatar.png')" 
      class="flex-shrink-0 mr-2" size="30px" 
      @click="$router.push(url)"
      />
      <router-link :to="url" @click.stop.prevent class="flex flex-col text-inherit hover:text-primary" style="line-height: normal;">
        <p style="color: black;">{{ params.data.referUser.firstname + ' ' + params.data.referUser.lastname }}</p>
        <p style="font-size: 12px;">{{params.data.referUser.email}}</p>
      </router-link>
      
  </div>
</template>

<script>
export default {
  name: 'CellRendererVerified',
  computed: {
    url() {
      return '/engineer/engineer-view/' + this.params.data.referUser._id;

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
};
</script>
